// extracted by mini-css-extract-plugin
export default {"flex-column":"people_flex-column__YLau+","header":"people_header__uSfXX","flex-row":"people_flex-row__pR8jB","page-size":"people_page-size__nrGi6"};